//

import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ALIGN, ILandingSection, VernissageContent } from "src/modules/pe-landing-module/data/interfaces"
import VernissagePrimitive from "../primitive/VernissagePrimitive"
import Dummy from "./Dummy"
import vernissages from "src/modules/pe-landing-module/data/utils/vernissages-600"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface IVernissageProps {
    section: ILandingSection
    data: VernissageContent
}
const Vernissage = ({data, ...props}: IVernissageProps): JSX.Element => { 
    const design_type: any  = vernissages()[ data.design_type || 0 ]
    const [marginLeft]      = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find( e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]     = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find( e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]       = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find( e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find( e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]      = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find( e => e === data.vertical_align) || !data.vertical_align ? "center" : "center")
    const [justify]         = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find( e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "center")
    const [height, ]        = useState<string>( getCssDemention( design_type.height, "920px" ) )

    useEffect(() => {
        addCSSClass(
            `landing-vernissage-${data.id}`,
            `.landing-vernissage-${data.id} {
                display: flex;
                align-items: ${alignItems};
                /*justify-content: ${justify};*/
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};                
                max-height: ${ height }; 
                height: ${ height }!important;
                z-index:1;
                position: relative;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-vernissage-${data.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return !!data.src  || true
        ?
        <div className={`landing-content-container landing-vernissage-${data.id} ${ data.className || "" } `} style={ data.style || {} }  data-type={data.type} data-content-id={data.id}>
            <VernissagePrimitive
                primitive={ {
                    ...( data ), 
                } as any }
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {...data, className: `landing-vernissage-${data.id}`}, 
            ...props 
        }} /> 
}
export default Vernissage